<template>
  <div>
    <!-- @details-opened="detailsOpened" -->
    <common-dialog
      ref="dialog"
      width="750px"
      unit="注塑工单批量下达"
      id-key="UserId"
      form-label-width="120px"
      @opened="openedDialog"
      @close-saved="$emit('close-saved')"
      @closed="$emit('onClosed')"
    >
        <template slot="form" >
          <el-row>
            <el-col :span="12">
              <div>
                <el-form-item label="生产类型">
                  <div>{{ lineData[0]?.ProductionType ? '委外' : '自制'}}</div>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="12">
              <p style="margin:5px 0 0 50px;color:red">
                注：只有同一生产类型工单，才可下达任务
              </p>
            </el-col>
          </el-row>
          
          <el-row>
            <el-col :span="12">
              <div>
                <el-form-item label="下达号">
                  <el-input v-model="params.ReleaseDocNo" />
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="12">
              <div>
                <el-form-item label="下达日期">
                  <el-date-picker
                    size="mini"
                    v-model="params.ReleaseTime"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-form-item>
              </div>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <div>
                <el-form-item label="下达生产部门">
                  <dp-select
                    style="width: 180px"
                    v-model="params.DpId"
                  />
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="12">
              <div>
                <el-form-item label="下达加工商">
                  <el-autocomplete
                    v-model="params.ProductionDpValue"
                    value-key="value"
                    :fetch-suggestions="querySearch"
                    @select="handleSelect"
                  ></el-autocomplete>
                </el-form-item>
              </div>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <div>
                <el-form-item label="开始日期">
                  <el-date-picker
                    size="mini"
                    v-model="params.StartTime"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="12">
              <div>
                <el-form-item label="预计完成日期">
                  <el-date-picker
                    size="mini"
                    v-model.trim="params.EndTime"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <p style="text-align: center;color:#365798">提示：所勾选工单有厂商/部门，预计完成日期有不相同的情况</p>
        </template>

      <template slot="footer">
        <el-button type="primary" @click="save">保存</el-button>
        <el-button type="primary" @click="onOrder">下达</el-button>
        <el-button @click="close">取消</el-button>
        <!-- <el-button type="primary" @click="save">确定</el-button>
        <el-button @click="close">关闭</el-button> -->
      </template>
    </common-dialog>
  
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import dpSelect from "@/components/production/clothmanagement/cloth/workorder/dpSelect";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    dpSelect
  },
  props: {
    lineData: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      warehouseApi: require("@/api/ba/warehouse").default,
      api: require("@/api/production/workDoc").default,
      tradeUnitApi: require("@/api/ba/tradeUnit").default,
      code_api: require("@/api/sy/serialCode").default,
      workDocApi: require("@/api/production/workDoc").default,
      params:{
        WorkDocIds:[],
        ReleaseDocNo:'',
        ReleaseTime:'',
        ProductionDpId:'',
        ProductionDpValue:'',
        DpId:'',
        StartTime:'',
        EndTime:'',
      },
      restaurants: [],
    };
  },
  computed: {
    // 获取当前时间
    timeDefault() {
      var date = new Date();
      var s1 = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + (date.getDate());
      return s1;
    },
    // 获取七天后的日期
    getSevenDaysLater() {
      var date = new Date();
      date.setDate(date.getDate() + 7); // 加上七天
      var s1 = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
      return s1;
    }
  },
  methods: {
    // 初始化
    openedDialog(){
      
      this.params.ReleaseTime = this.timeDefault;
      this.params.StartTime = this.timeDefault;
      this.params.EndTime = this.getSevenDaysLater;

      this.params.WorkDocIds = []
      this.params.ReleaseDocNo = ''
      this.lineData.forEach(item => {
        this.params.WorkDocIds.push(item.WorkDocId)
      })
      this.serialCode()
      this.getProcessor()
    },
    /** 获取下达号 */
    serialCode() {
      this.code_api.previewNo("工单下达编号").then((res) => {
        console.log("serialType", res);
        if (res.Code == 0) {
          this.params.ReleaseDocNo = res.Data.PreviewNo;
        } else {
          this.$message.warning("获取工单下达编号失败");
        }
      });
      console.log(this.params);
    },
    /** 获取加工商 */
    getProcessor(){
      let that = this
      this.tradeUnitApi.list({TradeUnitType: 3}).then((res)=>{
        that.restaurants = res.Data.map(i=>{
        return {
          value: i.FullName,
          id: i.TradeUnitId
        }
        })
      })
    },
    /** 关闭弹框 */
    close(){
      this.restaurants = []
      this.$refs.dialog.close(true)
    },
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    handleSelect(item) {
      this.params.ProductionDpId =  item.id
      this.params.ProductionDpValue = item.value;
    },
    /** 下达 */
    async onOrder(){
      console.log('下达');
      console.log(this.params);
      await this.workDocApi.releaseReview(this.params).then(res=>{
        console.log(res);
        if (res.Code == 0) {
          this.$message.success("下达成功");
          this.$emit('close-saved')
          this.$parent.reload()
          this.$refs.dialog.close(true)
        } else {
          this.$parent.reload()
          this.$message.warning(res.Msg);
          this.$refs.dialog.close(true)
        }
      })
    },
    /** 保存 */
    async save(){
      console.log('保存');
      console.log(this.params);
      await this.workDocApi.releaseSave(this.params).then(res=>{
        console.log(res);
        if (res.Code == 0) {
          this.$message.success("保存成功");
          this.$emit('close-saved')
          this.$parent.reload()
          this.$refs.dialog.close(true)
        } else {
          this.$parent.reload()
          this.$message.warning(res.Msg);
          this.$refs.dialog.close(true)
        }
      })
    },
  }

};
</script>


